<template>
  <v-card
    outlined
    tile
    :to="{name: 'car', params: {carid: car.id}}"
  >
    <v-row class="px-3">
      <v-col cols="12" sm="6">
        <v-img
          :src="car.images[0]"
          :aspect-ratio="4/3"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <div class="caption">{{car.maker}}</div>
        <div>{{car.name}}</div>

        <div class="grey--text text--darken-2 body-2 mt-3 mb-4">
          <div>{{carTypeName}}</div>
          <div class="mb-2">
            <span class="mr-1">{{displacementText}}</span>
            <span class="mr-1">{{fuelText}}</span>
            <span class="mr-1">/</span>
            <span class="mr-1">{{driveText}}</span>
            <span class="mr-1">/</span>
            <span class="mr-1">{{car.seat}}人乗り</span>
          </div>
          <div>1日 {{car.dayprice | comma}} 円<small class="ml-1">(税込)</small></div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import * as C from '@/app/special/consts'

export default {
  name: 'CarItem',
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  computed: {
    carTypeName () {
      const name = C.cartypeNames[this.car.type]
      return name || ''
    },
    missionText () {
      const item = this.car.specs.find(item => item.name === 'ギア')
      if (!item) {
        return 'AT'
      }
      return item.value
    },
    driveText () {
      const item = this.car.specs.find(item => item.name === '駆動')
      if (!item) {
        return '2WD'
      }
      return item.value
    },
    fuelText () {
      const item = this.car.specs.find(item => item.name === '燃料')
      if (!item) {
        return 'ガソリン'
      }
      return item.value
    },
    displacementText () {
      const item = this.car.specs.find(item => item.name === '排気量')
      if (!item) {
        return '-- L'
      }
      return (item.value / 1000) + 'L'
    }
  },
  filters: {
    comma (n) {
      return n.toLocaleString()
    }
  }
}
</script>
